export const BPA_SEVERITY_CONFIG = [
  { value: 4, label: 'Critical', color: '#146FBF' },
  { value: 3, label: 'High', color: '#0096FF' },
  { value: 2, label: 'Medium', color: '#5FCFFF' },
  { value: 1, label: 'Low', color: '#C2EDFF' },
] as const;

export const BPA_STATUS_COLORS: Record<string, string> = {
  Active: '#055193',
  Fixed: '#C2EDFF',
  Ignored: 'rgba(10, 161, 221, 1)',
};

export const BPA_HISTORY_COLORS = ['#055193', '#0096FF', '#5FCFFF', '#C2EDFF'];
export const BPA_PROVIDER_DASHBOARD_CONFIG: Record<
  string,
  { color: string; order: number }
> = {
  AWS: { color: '#055193', order: 10 },
  GCP: { color: '#0096FF', order: 20 },
  AZURE: { color: '#5FCFFF', order: 30 },
};

const normalizeProvider = (provider: string) => provider.toUpperCase();

const getFallbackProviderColor = (provider: string) => {
  const colorIndex = normalizeProvider(provider)
    .split('')
    .reduce((total, character) => total + character.charCodeAt(0), 0);
  return BPA_HISTORY_COLORS[colorIndex % BPA_HISTORY_COLORS.length];
};

export const getBPAProviderColor = (provider: string) =>
  BPA_PROVIDER_DASHBOARD_CONFIG[normalizeProvider(provider)]?.color ||
  getFallbackProviderColor(provider);

export const sortBPAProviders = <
  T extends { provider: string; name?: string; label?: string },
>(
  providers: readonly T[],
) =>
  [...providers].sort((left, right) => {
    const leftConfig =
      BPA_PROVIDER_DASHBOARD_CONFIG[normalizeProvider(left.provider)];
    const rightConfig =
      BPA_PROVIDER_DASHBOARD_CONFIG[normalizeProvider(right.provider)];

    if (leftConfig && rightConfig) return leftConfig.order - rightConfig.order;
    if (leftConfig) return -1;
    if (rightConfig) return 1;

    const leftName = left.name || left.label || left.provider;
    const rightName = right.name || right.label || right.provider;
    return (
      leftName.localeCompare(rightName) ||
      left.provider.localeCompare(right.provider)
    );
  });

export const BPA_DESELECTED_COLOR = 'rgba(128, 128, 128, 0.2)';
